module.exports = __webpack_public_path__ + "media/images/infinite_shop-2023-2-0952b6d18cd174a7495d7363c78a8453.png";